export default "__VITE_ASSET__B$gEOS_d__"